import React from "react";
import LabelValuePair from "../common/LabelValuePair";
import {AuditLog, AuditLogTypeLabels,} from "../../models/AuditLog";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

import { dialogNarrow } from "@/lib/dialogSize";

export const ViewClientSetToPendingUninstallDetailsModal: React.FC<{
  auditLog: AuditLog | null;
  open: boolean;
  onClose: () => void;
}> = ({ auditLog, open, onClose }) => {

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className={`${dialogNarrow} overflow-hidden`}>
        {auditLog ? (
          <>
            <DialogHeader>
              <DialogTitle>
                {AuditLogTypeLabels[auditLog.eventType]}
              </DialogTitle>
            </DialogHeader>

            <Separator />

            {(() => {
              // A blacklist reset names the build it cleared; the other client entries carry nothing extra.
              if (!auditLog.additionalData) return null;
              try {
                const data = JSON.parse(auditLog.additionalData);
                if (!data.Version) return null;
                return <LabelValuePair label="Version" value={`${data.ApplicationType ?? ""} ${data.Version}`.trim()} />;
              } catch {
                return null;
              }
            })()}

            <LabelValuePair
              label="Client ID"
              value={auditLog.entityId!}
            />

            <LabelValuePair
              label="Performed By"
              value={auditLog.performerEmailAddress}
            />

            <LabelValuePair
              label="Event Date"
              value={auditLog.eventDate}
            />
          </>
        ) : (
          <div />
        )}
      </DialogContent>
    </Dialog>
  );
};
